module.exports = __webpack_public_path__ + "media/site/images/ecommerce/ecommerce-solutions-for-any-device.de@1x-196753341e67c96c1a0fd8148bfe8d47.png";